import { createGlobalStyle } from 'styled-components'

import { drawerSidebarSizeVariables } from '@/presentation/modules/Base/components/Drawer/Drawer.styles'

export const GlobalStyle = createGlobalStyle`
  :root {
    ${drawerSidebarSizeVariables}
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    color: ${({ theme }) => theme.colors.neutralL5};

    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;

    user-select: none;
  }

  body {
    -webkit-font-smoothing: antialiased;
  }

  #root {
    height: 100vh;
  }

  textarea:focus, input:not([type='button']):focus, select:focus {
    box-shadow: 0 0 0 0;
    border: 0 none;
    outline: 0;
  }

  /* The @nexds/web Radio draws its circle on an <input type="button">: the reset above erased that circle
     on focus and left keyboard users with no focus indicator at all (PLA-294). */
  input[type='button']:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primaryL1};
    outline-offset: 2px;
  }

    & .recharts-surface:focus {
    outline: none;
  }
`
